export default __webpack_public_path__ + "static/B0074-c71ed0d5fa06c49a036ccc8f1fdfc476.png";